// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {

  production: false,


  appUrl: 'https://api.buyrentsale.com/',
  apiUrl: 'https://api.buyrentsale.com/',
  smsUrl: 'https://restapi.smscountry.com/v0.1/Accounts/tkEmYgbGJaaamgrtVhzo/SMSes/',
  isSendSMS: true,
  senderId: 'AINXIT',
  appLogoURL: 'https://buyrentsale.com/assets/images/logo-2.png',
  assetsBaseUrl: 'https://buyrentsale.com/assets/icons',
  kmlBaseUrl: 'https://uat.buyrentsale.com/lakes/',


  /*
    appUrl: 'https://uat.buyrentsale.com/',
    apiUrl: 'https://uatapi.buyrentsale.com/',
    smsUrl: 'https://restapi.smscountry.com/v0.1/Accounts/tkEmYgbGJaaamgrtVhzo/SMSes/',
    isSendSMS: true,
    senderId: 'AINXIT',
    appLogoURL: 'https://uat.buyrentsale.com/assets/images/logo-2.png',
    assetsBaseUrl: 'https://uat.buyrentsale.com/assets/icons', // ✅ add this line
    kmlBaseUrl: 'https://uat.buyrentsale.com/lakes/', // ✅ Add this
  */

  openAiApiKey: '',
  groqApiKey: '',




};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
